import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';

import { ClickAwayListener, IconButton, Switch, Tooltip } from '@mui/material';
import { useState } from 'react';


const CampaignsRow = ({ row, updateForm, onDelete, handleActive, updateEngine, index }) => {
  const [open, setOpen] = useState(false)
  const [openUrl, setOpenUrl] = useState(false)


  return (
    <>
      <TableCell key={index} component="th" align="center" scope="row" style={{ maxWidth: '50px' }}>
        {row.IdCamp}
      </TableCell>
      <TableCell key={index} align="center" style={{ maxWidth: '130px' }}>{row.Campaign}</TableCell>
      <TableCell key={index} align="center" style={{ maxWidth: '150px' }}>
        {row.Token}
        <ClickAwayListener onClickAway={() => { setOpen(false) }}>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={() => setOpen(false)}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title="Copied"
          >
            <IconButton onClick={() => {
              navigator.clipboard.writeText(row.Token)
              setOpen(!open)
            }}>
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>

        </ClickAwayListener>
      </TableCell>
      <TableCell key={index} align="center" style={{ maxWidth: '150px' }}>{row.CreateDate}</TableCell>
      <TableCell key={index} align="center" >{row.engineActive === '1' ? <CheckIcon /> : <CloseIcon />}</TableCell>
      <TableCell key={index} align="center">
        <Switch checked={row.Active === '1' ? true : (row.Active ? true : false)} onChange={(e) => { handleActive(row.IdCamp, e.target.checked ? '1' : '0') }} />
      </TableCell>
      <TableCell key={index} align="center">
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Edit Engines">
          <IconButton onClick={() => { updateEngine(row.IdCamp) }}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>


        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdCamp) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default CampaignsRow;